/* 3c045d243802b9bfbc92df357de5340b73b9a66d
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CurrentCustomerQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentCustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', phone_number: string, firstname?: string | null, lastname?: string | null, middlename?: string | null, email?: string | null } | null };

export type LoginCustomerByUsernameAndPasswordMutationVariables = Types.Exact<{
  phoneNumber: Types.Scalars['String']['input'];
  password: Types.Scalars['String']['input'];
  device?: Types.InputMaybe<Types.LoginDevice>;
}>;


export type LoginCustomerByUsernameAndPasswordMutation = { __typename?: 'Mutation', loginCustomerByUsernameAndPassword: { __typename?: 'CustomerToken', access_token?: string | null, expires_in?: number | null, id_token?: string | null, refresh_token?: string | null, token_type?: string | null } };

export type RequestValidatePhoneMutationVariables = Types.Exact<{
  phoneNumber: Types.Scalars['String']['input'];
  validateType: Types.ValidatePhoneType;
  notificationChannel: Types.NotificationChannel;
  captchaResponseToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sign?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type RequestValidatePhoneMutation = { __typename?: 'Mutation', requestValidatePhone: { __typename?: 'RequestValidatePhoneResponse', error_code?: string | null, message?: string | null, secret?: string | null, success: boolean } };

export type LoginWithPhoneAndOtpMutationVariables = Types.Exact<{
  phoneNumber: Types.Scalars['String']['input'];
  otp: Types.Scalars['String']['input'];
  secret: Types.Scalars['String']['input'];
  sign: Types.Scalars['String']['input'];
  device: Types.LoginDevice;
}>;


export type LoginWithPhoneAndOtpMutation = { __typename?: 'Mutation', loginWithPhoneAndOtp: { __typename?: 'CustomerToken', access_token?: string | null, expires_in?: number | null, id_token?: string | null, refresh_token?: string | null, token_type?: string | null } };

export type ResetPasswordByOtpMutationVariables = Types.Exact<{
  phoneNumber: Types.Scalars['String']['input'];
  otp: Types.Scalars['String']['input'];
  secret: Types.Scalars['String']['input'];
  newPassword: Types.Scalars['String']['input'];
}>;


export type ResetPasswordByOtpMutation = { __typename?: 'Mutation', resetPasswordByOtp: { __typename?: 'ResetPasswordResponse', message: string, success: boolean } };

export type InitiatePasswordResetByPhoneMutationVariables = Types.Exact<{
  phoneNumber: Types.Scalars['String']['input'];
}>;


export type InitiatePasswordResetByPhoneMutation = { __typename?: 'Mutation', initiatePasswordResetByPhone: { __typename?: 'GeneratedOtpTokenResponse', secret: string } };

export type ValidateResetPasswordTokenMutationVariables = Types.Exact<{
  phoneNumber: Types.Scalars['String']['input'];
  otp: Types.Scalars['String']['input'];
  secret: Types.Scalars['String']['input'];
}>;


export type ValidateResetPasswordTokenMutation = { __typename?: 'Mutation', validateResetPasswordToken: { __typename?: 'ResetPasswordResponse', message: string, success: boolean } };

export type ConfirmRequestedValidationPhoneMutationVariables = Types.Exact<{
  phoneNumber: Types.Scalars['String']['input'];
  otp: Types.Scalars['String']['input'];
  secret: Types.Scalars['String']['input'];
}>;


export type ConfirmRequestedValidationPhoneMutation = { __typename?: 'Mutation', confirmRequestedValidationPhone: { __typename?: 'ConfirmRequestedValidationPhoneResponse', message?: string | null, success: boolean, secret?: string | null } };

export type RegisterNewAccountByOtpMutationVariables = Types.Exact<{
  phoneNumber: Types.Scalars['String']['input'];
  otp: Types.Scalars['String']['input'];
  secret: Types.Scalars['String']['input'];
  accountInfo: Types.RegisterAccountInfo;
  deviceRequest?: Types.InputMaybe<Types.LoginDevice>;
}>;


export type RegisterNewAccountByOtpMutation = { __typename?: 'Mutation', registerNewAccountByOtp: { __typename?: 'RegisterResponse', message?: string | null, success: boolean } };

export type RefreshTokenMutationVariables = Types.Exact<{
  refreshToken: Types.Scalars['String']['input'];
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'CustomerToken', access_token?: string | null, refresh_token?: string | null, expires_in?: number | null, token_type?: string | null, id_token?: string | null } };


export const CurrentCustomerDocument = gql`
    query CurrentCustomer {
  customer {
    phone_number
    firstname
    lastname
    middlename
    email
  }
}
    `;

/**
 * __useCurrentCustomerQuery__
 *
 * To run a query within a React component, call `useCurrentCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentCustomerQuery(baseOptions?: Apollo.QueryHookOptions<CurrentCustomerQuery, CurrentCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentCustomerQuery, CurrentCustomerQueryVariables>(CurrentCustomerDocument, options);
      }
export function useCurrentCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentCustomerQuery, CurrentCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentCustomerQuery, CurrentCustomerQueryVariables>(CurrentCustomerDocument, options);
        }
export function useCurrentCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentCustomerQuery, CurrentCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentCustomerQuery, CurrentCustomerQueryVariables>(CurrentCustomerDocument, options);
        }
export type CurrentCustomerQueryHookResult = ReturnType<typeof useCurrentCustomerQuery>;
export type CurrentCustomerLazyQueryHookResult = ReturnType<typeof useCurrentCustomerLazyQuery>;
export type CurrentCustomerSuspenseQueryHookResult = ReturnType<typeof useCurrentCustomerSuspenseQuery>;
export type CurrentCustomerQueryResult = Apollo.QueryResult<CurrentCustomerQuery, CurrentCustomerQueryVariables>;
export const LoginCustomerByUsernameAndPasswordDocument = gql`
    mutation LoginCustomerByUsernameAndPassword($phoneNumber: String!, $password: String!, $device: LoginDevice) {
  loginCustomerByUsernameAndPassword(
    phone_number: $phoneNumber
    password: $password
    device: $device
  ) {
    access_token
    expires_in
    id_token
    refresh_token
    token_type
  }
}
    `;
export type LoginCustomerByUsernameAndPasswordMutationFn = Apollo.MutationFunction<LoginCustomerByUsernameAndPasswordMutation, LoginCustomerByUsernameAndPasswordMutationVariables>;

/**
 * __useLoginCustomerByUsernameAndPasswordMutation__
 *
 * To run a mutation, you first call `useLoginCustomerByUsernameAndPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginCustomerByUsernameAndPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginCustomerByUsernameAndPasswordMutation, { data, loading, error }] = useLoginCustomerByUsernameAndPasswordMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      password: // value for 'password'
 *      device: // value for 'device'
 *   },
 * });
 */
export function useLoginCustomerByUsernameAndPasswordMutation(baseOptions?: Apollo.MutationHookOptions<LoginCustomerByUsernameAndPasswordMutation, LoginCustomerByUsernameAndPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginCustomerByUsernameAndPasswordMutation, LoginCustomerByUsernameAndPasswordMutationVariables>(LoginCustomerByUsernameAndPasswordDocument, options);
      }
export type LoginCustomerByUsernameAndPasswordMutationHookResult = ReturnType<typeof useLoginCustomerByUsernameAndPasswordMutation>;
export type LoginCustomerByUsernameAndPasswordMutationResult = Apollo.MutationResult<LoginCustomerByUsernameAndPasswordMutation>;
export type LoginCustomerByUsernameAndPasswordMutationOptions = Apollo.BaseMutationOptions<LoginCustomerByUsernameAndPasswordMutation, LoginCustomerByUsernameAndPasswordMutationVariables>;
export const RequestValidatePhoneDocument = gql`
    mutation RequestValidatePhone($phoneNumber: String!, $validateType: ValidatePhoneType!, $notificationChannel: NotificationChannel!, $captchaResponseToken: String, $sign: String) {
  requestValidatePhone(
    phone_number: $phoneNumber
    validateType: $validateType
    notificationChannel: $notificationChannel
    captchaResponseToken: $captchaResponseToken
    sign: $sign
  ) {
    error_code
    message
    secret
    success
  }
}
    `;
export type RequestValidatePhoneMutationFn = Apollo.MutationFunction<RequestValidatePhoneMutation, RequestValidatePhoneMutationVariables>;

/**
 * __useRequestValidatePhoneMutation__
 *
 * To run a mutation, you first call `useRequestValidatePhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestValidatePhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestValidatePhoneMutation, { data, loading, error }] = useRequestValidatePhoneMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      validateType: // value for 'validateType'
 *      notificationChannel: // value for 'notificationChannel'
 *      captchaResponseToken: // value for 'captchaResponseToken'
 *      sign: // value for 'sign'
 *   },
 * });
 */
export function useRequestValidatePhoneMutation(baseOptions?: Apollo.MutationHookOptions<RequestValidatePhoneMutation, RequestValidatePhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestValidatePhoneMutation, RequestValidatePhoneMutationVariables>(RequestValidatePhoneDocument, options);
      }
export type RequestValidatePhoneMutationHookResult = ReturnType<typeof useRequestValidatePhoneMutation>;
export type RequestValidatePhoneMutationResult = Apollo.MutationResult<RequestValidatePhoneMutation>;
export type RequestValidatePhoneMutationOptions = Apollo.BaseMutationOptions<RequestValidatePhoneMutation, RequestValidatePhoneMutationVariables>;
export const LoginWithPhoneAndOtpDocument = gql`
    mutation LoginWithPhoneAndOtp($phoneNumber: String!, $otp: String!, $secret: String!, $sign: String!, $device: LoginDevice!) {
  loginWithPhoneAndOtp(
    phone_number: $phoneNumber
    otp: $otp
    secret: $secret
    sign: $sign
    device: $device
  ) {
    access_token
    expires_in
    id_token
    refresh_token
    token_type
  }
}
    `;
export type LoginWithPhoneAndOtpMutationFn = Apollo.MutationFunction<LoginWithPhoneAndOtpMutation, LoginWithPhoneAndOtpMutationVariables>;

/**
 * __useLoginWithPhoneAndOtpMutation__
 *
 * To run a mutation, you first call `useLoginWithPhoneAndOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithPhoneAndOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithPhoneAndOtpMutation, { data, loading, error }] = useLoginWithPhoneAndOtpMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      otp: // value for 'otp'
 *      secret: // value for 'secret'
 *      sign: // value for 'sign'
 *      device: // value for 'device'
 *   },
 * });
 */
export function useLoginWithPhoneAndOtpMutation(baseOptions?: Apollo.MutationHookOptions<LoginWithPhoneAndOtpMutation, LoginWithPhoneAndOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginWithPhoneAndOtpMutation, LoginWithPhoneAndOtpMutationVariables>(LoginWithPhoneAndOtpDocument, options);
      }
export type LoginWithPhoneAndOtpMutationHookResult = ReturnType<typeof useLoginWithPhoneAndOtpMutation>;
export type LoginWithPhoneAndOtpMutationResult = Apollo.MutationResult<LoginWithPhoneAndOtpMutation>;
export type LoginWithPhoneAndOtpMutationOptions = Apollo.BaseMutationOptions<LoginWithPhoneAndOtpMutation, LoginWithPhoneAndOtpMutationVariables>;
export const ResetPasswordByOtpDocument = gql`
    mutation ResetPasswordByOtp($phoneNumber: String!, $otp: String!, $secret: String!, $newPassword: String!) {
  resetPasswordByOtp(
    phone_number: $phoneNumber
    otp: $otp
    secret: $secret
    new_password: $newPassword
  ) {
    message
    success
  }
}
    `;
export type ResetPasswordByOtpMutationFn = Apollo.MutationFunction<ResetPasswordByOtpMutation, ResetPasswordByOtpMutationVariables>;

/**
 * __useResetPasswordByOtpMutation__
 *
 * To run a mutation, you first call `useResetPasswordByOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordByOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordByOtpMutation, { data, loading, error }] = useResetPasswordByOtpMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      otp: // value for 'otp'
 *      secret: // value for 'secret'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useResetPasswordByOtpMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordByOtpMutation, ResetPasswordByOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordByOtpMutation, ResetPasswordByOtpMutationVariables>(ResetPasswordByOtpDocument, options);
      }
export type ResetPasswordByOtpMutationHookResult = ReturnType<typeof useResetPasswordByOtpMutation>;
export type ResetPasswordByOtpMutationResult = Apollo.MutationResult<ResetPasswordByOtpMutation>;
export type ResetPasswordByOtpMutationOptions = Apollo.BaseMutationOptions<ResetPasswordByOtpMutation, ResetPasswordByOtpMutationVariables>;
export const InitiatePasswordResetByPhoneDocument = gql`
    mutation InitiatePasswordResetByPhone($phoneNumber: String!) {
  initiatePasswordResetByPhone(phone_number: $phoneNumber) {
    secret
  }
}
    `;
export type InitiatePasswordResetByPhoneMutationFn = Apollo.MutationFunction<InitiatePasswordResetByPhoneMutation, InitiatePasswordResetByPhoneMutationVariables>;

/**
 * __useInitiatePasswordResetByPhoneMutation__
 *
 * To run a mutation, you first call `useInitiatePasswordResetByPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiatePasswordResetByPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiatePasswordResetByPhoneMutation, { data, loading, error }] = useInitiatePasswordResetByPhoneMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useInitiatePasswordResetByPhoneMutation(baseOptions?: Apollo.MutationHookOptions<InitiatePasswordResetByPhoneMutation, InitiatePasswordResetByPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiatePasswordResetByPhoneMutation, InitiatePasswordResetByPhoneMutationVariables>(InitiatePasswordResetByPhoneDocument, options);
      }
export type InitiatePasswordResetByPhoneMutationHookResult = ReturnType<typeof useInitiatePasswordResetByPhoneMutation>;
export type InitiatePasswordResetByPhoneMutationResult = Apollo.MutationResult<InitiatePasswordResetByPhoneMutation>;
export type InitiatePasswordResetByPhoneMutationOptions = Apollo.BaseMutationOptions<InitiatePasswordResetByPhoneMutation, InitiatePasswordResetByPhoneMutationVariables>;
export const ValidateResetPasswordTokenDocument = gql`
    mutation ValidateResetPasswordToken($phoneNumber: String!, $otp: String!, $secret: String!) {
  validateResetPasswordToken(
    phone_number: $phoneNumber
    otp: $otp
    secret: $secret
  ) {
    message
    success
  }
}
    `;
export type ValidateResetPasswordTokenMutationFn = Apollo.MutationFunction<ValidateResetPasswordTokenMutation, ValidateResetPasswordTokenMutationVariables>;

/**
 * __useValidateResetPasswordTokenMutation__
 *
 * To run a mutation, you first call `useValidateResetPasswordTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateResetPasswordTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateResetPasswordTokenMutation, { data, loading, error }] = useValidateResetPasswordTokenMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      otp: // value for 'otp'
 *      secret: // value for 'secret'
 *   },
 * });
 */
export function useValidateResetPasswordTokenMutation(baseOptions?: Apollo.MutationHookOptions<ValidateResetPasswordTokenMutation, ValidateResetPasswordTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateResetPasswordTokenMutation, ValidateResetPasswordTokenMutationVariables>(ValidateResetPasswordTokenDocument, options);
      }
export type ValidateResetPasswordTokenMutationHookResult = ReturnType<typeof useValidateResetPasswordTokenMutation>;
export type ValidateResetPasswordTokenMutationResult = Apollo.MutationResult<ValidateResetPasswordTokenMutation>;
export type ValidateResetPasswordTokenMutationOptions = Apollo.BaseMutationOptions<ValidateResetPasswordTokenMutation, ValidateResetPasswordTokenMutationVariables>;
export const ConfirmRequestedValidationPhoneDocument = gql`
    mutation ConfirmRequestedValidationPhone($phoneNumber: String!, $otp: String!, $secret: String!) {
  confirmRequestedValidationPhone(
    phone_number: $phoneNumber
    otp: $otp
    secret: $secret
  ) {
    message
    success
    secret
  }
}
    `;
export type ConfirmRequestedValidationPhoneMutationFn = Apollo.MutationFunction<ConfirmRequestedValidationPhoneMutation, ConfirmRequestedValidationPhoneMutationVariables>;

/**
 * __useConfirmRequestedValidationPhoneMutation__
 *
 * To run a mutation, you first call `useConfirmRequestedValidationPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmRequestedValidationPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmRequestedValidationPhoneMutation, { data, loading, error }] = useConfirmRequestedValidationPhoneMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      otp: // value for 'otp'
 *      secret: // value for 'secret'
 *   },
 * });
 */
export function useConfirmRequestedValidationPhoneMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmRequestedValidationPhoneMutation, ConfirmRequestedValidationPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmRequestedValidationPhoneMutation, ConfirmRequestedValidationPhoneMutationVariables>(ConfirmRequestedValidationPhoneDocument, options);
      }
export type ConfirmRequestedValidationPhoneMutationHookResult = ReturnType<typeof useConfirmRequestedValidationPhoneMutation>;
export type ConfirmRequestedValidationPhoneMutationResult = Apollo.MutationResult<ConfirmRequestedValidationPhoneMutation>;
export type ConfirmRequestedValidationPhoneMutationOptions = Apollo.BaseMutationOptions<ConfirmRequestedValidationPhoneMutation, ConfirmRequestedValidationPhoneMutationVariables>;
export const RegisterNewAccountByOtpDocument = gql`
    mutation RegisterNewAccountByOtp($phoneNumber: String!, $otp: String!, $secret: String!, $accountInfo: RegisterAccountInfo!, $deviceRequest: LoginDevice) {
  registerNewAccountByOtp(
    phone_number: $phoneNumber
    otp: $otp
    secret: $secret
    accountInfo: $accountInfo
    deviceRequest: $deviceRequest
  ) {
    message
    success
  }
}
    `;
export type RegisterNewAccountByOtpMutationFn = Apollo.MutationFunction<RegisterNewAccountByOtpMutation, RegisterNewAccountByOtpMutationVariables>;

/**
 * __useRegisterNewAccountByOtpMutation__
 *
 * To run a mutation, you first call `useRegisterNewAccountByOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterNewAccountByOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerNewAccountByOtpMutation, { data, loading, error }] = useRegisterNewAccountByOtpMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      otp: // value for 'otp'
 *      secret: // value for 'secret'
 *      accountInfo: // value for 'accountInfo'
 *      deviceRequest: // value for 'deviceRequest'
 *   },
 * });
 */
export function useRegisterNewAccountByOtpMutation(baseOptions?: Apollo.MutationHookOptions<RegisterNewAccountByOtpMutation, RegisterNewAccountByOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterNewAccountByOtpMutation, RegisterNewAccountByOtpMutationVariables>(RegisterNewAccountByOtpDocument, options);
      }
export type RegisterNewAccountByOtpMutationHookResult = ReturnType<typeof useRegisterNewAccountByOtpMutation>;
export type RegisterNewAccountByOtpMutationResult = Apollo.MutationResult<RegisterNewAccountByOtpMutation>;
export type RegisterNewAccountByOtpMutationOptions = Apollo.BaseMutationOptions<RegisterNewAccountByOtpMutation, RegisterNewAccountByOtpMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($refreshToken: String!) {
  refreshToken(refresh_token: $refreshToken) {
    access_token
    refresh_token
    expires_in
    token_type
    id_token
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;